import './currency-7be6806c.js';
import { c as createStore } from './index-54dd34b7.js';

const pesPathnamePageType = {
    SITE: 'site',
    ALL_PRODUCTS: 'all-products',
    BUSINESS: 'business',
    CATEGORY: 'product-category',
    SUBCATEGORY: 'product-subcategory',
    RANGE: 'product-range',
    PRODUCT: 'product',
};
const pesCatalogPageTypes = {
    ALL_PRODUCTS: 'all-products',
    CATEGORY: 'category',
    SUBCATEGORY: 'subcategory',
    RANGE: 'range',
    PRODUCT: 'product',
};
const pesPathnamePageTypeToPageTypeMap = {
    [pesPathnamePageType.ALL_PRODUCTS]: pesCatalogPageTypes.ALL_PRODUCTS,
    [pesPathnamePageType.CATEGORY]: pesCatalogPageTypes.CATEGORY,
    [pesPathnamePageType.SUBCATEGORY]: pesCatalogPageTypes.SUBCATEGORY,
    [pesPathnamePageType.RANGE]: pesCatalogPageTypes.RANGE,
    [pesPathnamePageType.PRODUCT]: pesCatalogPageTypes.PRODUCT,
};
const pesRouterNavigationType = {
    HASH: 'hash',
    PATH: 'path',
    EVENT: 'event',
};

const store = createStore({
  navigation: pesRouterNavigationType.EVENT,
  bypass: false,
  usePesRouter: false,
  enableAppRouting: false,
  showCustomPrice: false,
});

export { pesRouterNavigationType as a, pesCatalogPageTypes as b, pesPathnamePageTypeToPageTypeMap as p, store as s };
